export default "__VITE_ASSET__e709e990__"